var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.075 5.91501C12.7175 5.91501 12.1625 4.95501 12.8375 3.77751C13.2275 3.09501 12.995 2.22501 12.3125 1.83501L11.015 1.09251C10.4225 0.740013 9.6575 0.950013 9.305 1.54251L9.2225 1.68501C8.5475 2.86251 7.4375 2.86251 6.755 1.68501L6.6725 1.54251C6.335 0.950013 5.57 0.740013 4.9775 1.09251L3.68 1.83501C2.9975 2.22501 2.765 3.10251 3.155 3.78501C3.8375 4.95501 3.2825 5.91501 1.925 5.91501C1.145 5.91501 0.5 6.55251 0.5 7.34001V8.66001C0.5 9.44001 1.1375 10.085 1.925 10.085C3.2825 10.085 3.8375 11.045 3.155 12.2225C2.765 12.905 2.9975 13.775 3.68 14.165L4.9775 14.9075C5.57 15.26 6.335 15.05 6.6875 14.4575L6.77 14.315C7.445 13.1375 8.555 13.1375 9.2375 14.315L9.32 14.4575C9.6725 15.05 10.4375 15.26 11.03 14.9075L12.3275 14.165C13.01 13.775 13.2425 12.8975 12.8525 12.2225C12.17 11.045 12.725 10.085 14.0825 10.085C14.8625 10.085 15.5075 9.44751 15.5075 8.66001V7.34001C15.5 6.56001 14.8625 5.91501 14.075 5.91501ZM8 10.4375C6.6575 10.4375 5.5625 9.34251 5.5625 8.00001C5.5625 6.65751 6.6575 5.56251 8 5.56251C9.3425 5.56251 10.4375 6.65751 10.4375 8.00001C10.4375 9.34251 9.3425 10.4375 8 10.4375Z",
    fill: "#3F7CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.bdbee6bd437cc1c4f22325984e59b886.svg";
export { ForwardRef as ReactComponent };